import api from 'utils/api';

export const REQUESTING_REFERRING_PROVIDERS = 'REQUESTING_REFERRING_PROVIDERS';
export const RECEIVE_REFERRING_PROVIDERS = 'RECEIVE_REFERRING_PROVIDERS';

function requestingReferringProviders() {
  return { type: REQUESTING_REFERRING_PROVIDERS };
}

function receiveReferringProviders(providers, receivedAt) {
  return { type: RECEIVE_REFERRING_PROVIDERS, referringProviders: providers, receivedAt };
}

const actions = {
  fetchReferringProviders(dispatch) {
    dispatch(requestingReferringProviders());
    return api.get('/agent_portal/api/referral_profiles/referring_providers').then(response => {
      dispatch(receiveReferringProviders(response.data.referringProviders, response.time));
      return response;
    });
  },
};

export default actions;
